var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var ArrowLeft = function () {
    return (_jsx("svg", __assign({ className: "custom_icon", viewBox: "0 0 10 10" }, { children: _jsx("path", { d: "M5 10L5.88125 9.11875L2.39375 5.625L10 5.625L10 4.375L2.39375 4.375L5.88125 0.881251L5 4.37114e-07L-4.37114e-07 5L5 10Z" }) })));
};
export var ArrowRight = function () {
    return (_jsx("svg", __assign({ className: "custom_icon", viewBox: "0 0 10 10" }, { children: _jsx("path", { d: "M5 0L4.11875 0.88125L7.60625 4.375L0 4.375L0 5.625L7.60625 5.625L4.11875 9.11875L5 10L10 5L5 0Z" }) })));
};
export var ArrowUp = function () {
    return (_jsx("svg", __assign({ className: "custom_icon", viewBox: "0 0 10 10" }, { children: _jsx("path", { d: "M-2.18557e-07 5L0.88125 5.88125L4.375 2.39375L4.375 10L5.625 10L5.625 2.39375L9.11875 5.88125L10 5L5 -2.18557e-07L-2.18557e-07 5Z" }) })));
};
export var ArrowDown = function () {
    return (_jsx("svg", __assign({ className: "custom_icon", viewBox: "0 0 10 10" }, { children: _jsx("path", { d: "M10 5L9.11875 4.11875L5.625 7.60625L5.625 5.21714e-08L4.375 6.70775e-08L4.375 7.60625L0.88125 4.11875L5.96244e-08 5L5 10L10 5Z" }) })));
};
